import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit'


export type TypeUserInfoProps = {  
  userId : string,
  userName : string,
  userCode : string,

}

const initialState: { userInfo: TypeUserInfoProps[] } = { userInfo: [] };	// 초기값

export const userInfoSlice = createSlice({
  name: "authInfo",
  initialState,
  reducers: {
    setUserInfo: ( 
      state,
      action: PayloadAction<TypeUserInfoProps[]>
    ) => {
      state.userInfo = action.payload;
    },
    
  },
  
});

export const {setUserInfo} = userInfoSlice.actions;

// slice를 내보냄
export default userInfoSlice.reducer;